<template>
  <div>

    <Dialog :visible.sync="exibirModal" header="Solicitação | Justificar | Atualizar" :modal="true" :style="{ width: '40vw' }" @hide="fechar">
      <div v-if="dados">
        <label class="p-text-bold">{{ dadosResiquicao.solicitacao.funcionario.nomecc }}</label>
        <hr>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-6">
            <label>Data da Solicitação</label>
            <InputText class="input-readonly" v-model.trim="dadosResiquicao.solicitacao.data" readonly />
          </div>
          <div class="p-field p-col-6">
            <label>Data do Ponto</label>
            <InputText class="input-readonly" v-model.trim="dadosResiquicao.solicitacao.dataPonto" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6" v-if="!desfazerAjuste">
            <label>Evento</label>
            <InputText class="input-readonly" v-model.trim="dados.itemPendente.infoCampo1" readonly />
          </div>
          <div class="p-field p-col-12 p-md-12" v-if="desfazerAjuste">
            <label>Desfazer Ajuste</label>
            <InputText class="input-readonly" v-model.trim="dados.itemPendente.infoCampo1" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6" v-if="!desfazerAjuste">
            <label>Justificativa</label>
            <InputText class="input-readonly" v-model.trim="dados.itemPendente.justificativa.descricao" readonly />
          </div>
          <div class="p-field p-col-12 p-md-12" v-if="!desfazerAjuste">
            <label>Observação</label>
            <Textarea class="input-readonly" v-model.trim="dados.itemPendente.observacao" rows="3" cols="30" readonly />
          </div>
          <div class="p-field p-col-12 p-md-12">
            <label class="p-text-bold">Ação</label>
            <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" optionValue="id"
              placeholder="Selecione" appendTo="body" :disabled="!exibirBotoes"
              :class="!exibirBotoes ? 'input-readonly' : ''" />
          </div>
          <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
            <label class="p-text-bold">Observação</label>
            <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30"
              :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes" />
          </div>
        </div>
      </div>
      <template #footer>
        <div class="p-d-flex p-jc-end">
          <div v-if="exibirBotoes">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirModal = false" />
            <Button label="Salvar" icon="pi pi-check" @click="salvar" />
          </div>
        </div>
      </template>
    </Dialog>

  </div>
</template>
  
<script>
import ControlePontoService from '@/service/ControlePontoService.js';
import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
  controlePontoService: null,
  props: {
    callback: Function,
  },
  data() {
    return {
      naoAprovado: 'Não Aprovado',
      exibirModal: false,
      eventoEncontrado: true,
      itemPendente: {},
      observacaoNaoAprovado: '',
      dadosResiquicao: null,
      dados: null,
      acaoSelecionada: '',
      acoes: acoesSolicitacoesPendentes,
      exibirBotoes: false,
      desfazerAjuste: false
    }
  },
  methods: {
    ...mapGetters('sessao', ['getDadosRequisicao']),
    /**
     * 
     * @param {*} dados 
     */
    processar(dados) {
      this.controlePontoService = new ControlePontoService();
      this.dadosResiquicao = dados;
      this.buscarItemSolicitacao();
    },
    /**
     * 
     */
    buscarItemSolicitacao() {
      let requisicao = {
        idSolicitacao: this.dadosResiquicao.solicitacao.id,
        idFuncionario: this.dadosResiquicao.solicitacao.funcionario.id,
        dataPonto: this.formartarStrData(this.dadosResiquicao.solicitacao.dataPonto, 'US'),
        usuarioRequisicao: { ...this.getDadosRequisicao() }
      };
      this.controlePontoService.buscarItemSolicitacaoJustificarEvento(requisicao)
        .then((resp) => {
          this.dados = resp.data;
          const solicitacao = this.dadosResiquicao.solicitacao;
          if (solicitacao.status === 'Pendente' && this.dadosResiquicao.permissaoEditar) {
            this.exibirBotoes = true;
          } else {
            this.acaoSelecionada = solicitacao.status;
          }
          if (!solicitacao.observacao) {
            this.dadosResiquicao.solicitacao.observacao = '';
          }
          this.observacaoNaoAprovado = solicitacao.observacao;
          if (!this.dados.itemPendente.justificativa) {
            this.desfazerAjuste = true;
          }
          this.exibirModal = true;
        })
        .catch((erro) => { exibirMensagem(this, erro); });
    },
    /**
     * 
     */
    salvar() {
      if (this.acaoSelecionada == '') {
        exibirMensagemSis(this, 'Selecione uma ação', true);
        return;
      }
      if (this.acaoSelecionada === this.naoAprovado
        && this.observacaoNaoAprovado === '') {
        exibirMensagemSis(this, 'Informe um texto breve na observação', true);
        return;
      }
      let solicitacao = clonar(this.dadosResiquicao.solicitacao);
      delete solicitacao.funcionario;
      solicitacao.status = this.acaoSelecionada;
      solicitacao.observacao = this.observacaoNaoAprovado;
      solicitacao['usuarioAprovacao'] = this.dadosResiquicao.requisicao.usuarioRequisicao.usuario.nome;
      this.resolverPendenciaAlteracao(solicitacao);
    },
    /**
     * 
     * @param {*} solicitacaoAtualizar 
     */
    resolverPendenciaAlteracao(solicitacaoAtualizar) {
      const evento = this.pesquisarEvento();
      const eventos = [];
      if (evento) {
        if (this.dados.itemPendente.justificativa) {
          evento.selecionar = true;
          evento.observacao = this.dados.itemPendente.observacao;
          evento.usuarioJustificativa = this.dados.itemPendente.infoCampo3;
          evento['justificativa'] = this.dados.itemPendente.justificativa;
        } else {
          evento.desfazer = true;
        }
        eventos.push(evento);
      }
      const novaRequisicao = {
        mes: this.dadosResiquicao.requisicao.mes,
        ano: this.dadosResiquicao.requisicao.ano,
        dataInicio: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
        dataFinal: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
        solicitacao: solicitacaoAtualizar,
        idFuncionario: this.dadosResiquicao.solicitacao.funcionario.id,
        eventos: eventos,
        usuarioRequisicao: this.dadosResiquicao.requisicao.usuarioRequisicao
      };
      this.controlePontoService
        .salvarEventoJustificativaPendente(novaRequisicao)
        .then((resp) => {
          this.fechar();
          exibirMensagem(this, resp);
          this.callback(solicitacaoAtualizar);
        })
        .catch((erro) => {
          exibirMensagem(this, erro);
        });
    },
    /**
     * 
     */
    pesquisarEvento() {
      let eventos = this.dados.naoJustificados;
      if (!this.dados.itemPendente.justificativa) {
        eventos = this.dados.justificados
      }
      let evento = null;
      eventos.forEach(evv => {
        if (evv.evento.codigo == this.dados.itemPendente.codigoEventoJustificado) {
          evento = clonar(evv);
        }
      });
      return evento;
    },
    /**
     *
     * @param {*} strData
     * @param {*} formato
     */
    formartarStrData(strData, formato) {
      if (formato == "BR") {
        let partes = strData.split("-");
        return partes[2] + "/" + partes[1] + "/" + partes[0];
      }
      let partes = strData.split("/");
      return partes[2] + "-" + partes[1] + "-" + partes[0];
    },
    /**
     * 
     */
    fechar() {
      this.controlePontoService = null;
      this.exibirModal = false;
      this.eventoEncontrado = true;     
      this.observacaoNaoAprovado = '';
      this.dados = null;
      this.dadosResiquicao = null;
      this.acaoSelecionada = '';
      this.exibirBotoes = false;
      this.desfazerAjuste = false;
    }
  }
}
</script>
  
<style scoped>
.input-readonly {
  background-color: #F2F2F2;
}
</style>